var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/notification_icon.d4a64386.png","uri@2x": __webpack_public_path__ + "static/media/notification_icon.097a9297.png","uri@3x": __webpack_public_path__ + "static/media/notification_icon.e45b00af.png",
    width: 20,
    height: 20
});